import moment from 'moment';


export const subtractDays=(date1, date2)=>{
  // Convert date strings to Date objects
  const dateObj1 = new Date(date1);
  const dateObj2 = new Date(date2);

  // Calculate the difference in milliseconds
  const diffInMilliseconds = Math.abs(dateObj2 - dateObj1);

  // Convert milliseconds to days
  const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));

  return diffInDays;
}

export const toDate = (timestamp, { order = 'ymd', delim = '-' } = {}) => {
    const dt = new Date(timestamp * 1000);
    const year = dt.getFullYear();
    const month = ('0' + (dt.getMonth() + 1)).slice(-2);
    const day = ('0' + dt.getDate()).slice(-2);

    // Create a mapping for order variations
    const dateMap = {
        'ymd': [year, month, day],
        'mdy': [month, day, year],
        'dmy': [day, month, year]
    };

    // Ensure order parameter is valid
    if (!dateMap[order]) {
        throw new Error(`Invalid order parameter: ${order}`);
    }

    return dateMap[order].join(delim);
};

export const toDateTime = (timestamp)=>{
    let dt = new Date(timestamp*1000);
    let year = dt.getFullYear();
    let month = ('0' + (dt.getMonth() + 1)).slice(-2); // Months are zero-based
    let day = ('0' + dt.getDate()).slice(-2);
    let hour = ('0' + dt.getHours()).slice(-2);
    let minute = ('0' + dt.getMinutes()).slice(-2);
    return `${year}/${month}/${day} ${hour}:${minute}`;
}


/**
 * Get the number of days between two unix timestamps
 * @param timestamp1
 * @param timestamp2
 * @returns {number}
 */
export const getDeltaDaysFromTimestamps = (timestamp1, timestamp2)=>{
  // Calculate the difference in milliseconds
  const diffInMilliseconds = Math.abs(timestamp2 - timestamp1);

  // Convert milliseconds to days
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

  // Round the result to a desired number of decimal places (e.g., 2)
  const decimalDays = Math.round(diffInDays * 100) / 100;

  return decimalDays;
}



const isWeekday = (date) => {
  const day = date.day();
  return day !== 0 && day !== 6;
};

// Function to create a future date range with weekdays only
export const createFutureDateRange = (n, unit='days') => {
  const dates = [];
  let currentDate = moment();

  while (dates.length < n) {
    currentDate = currentDate.add(1, unit);
    if (isWeekday(currentDate)) {
      dates.push(currentDate.format('YYYY-MM-DD'));
    }
  }

  return dates;
};